import React from "react";
import { Col, Row } from "react-bootstrap";
import { Panel, PanelGroup } from "rsuite";
import { useTranslation } from "react-i18next";
import img from '../../assets/faq-illustration.png'

const Faq = () => {

  const { t } = useTranslation();

  const faqData = t("faq_data", { returnObjects: true });
 return(<></>)


  // faqData.sort(() => Math.random() - 0.5);

  // const selectedFaqItems = faqData.slice(0, 4);

  // return (
  //   <div className="text-dark py-3">
  //     <Row className="justify-content-between align-items-center">

  //       <Col lg="7" className="my-3">
  //         <div className="fs-4 fw-medium text-blue">{t("frequently_asked_questions")}</div>
  //         <p className="fs-6 my-3 fw-light">{t('faq_intro')}</p>
  //         <PanelGroup accordion>
  //           {selectedFaqItems.map((item, index) => (
  //             <div key={index} className="shadow-sm border border-white my-3 rounded-4 p-2">
  //               <Panel header={<div className="fw-medium">{item.title}</div>}>
  //                 <p className="fs-6 fw-light">{item.content}</p>
  //               </Panel>
  //             </div>
  //           ))}
  //         </PanelGroup>
  //       </Col>
  //       <Col md="6" lg="4" className="my-3">
  //         <div className="p-5 d-flex flex-column align-items-center gradient-blue text-white rounded-4">
  //           <img
  //             src={img}
  //             alt="illustration faq"
  //             width="260"
  //             height="260"
  //           />

  //           <div className="fs-4">{t('still_got_questions')}</div>
  //           <p className="opacity-75 mt-2 fs-5">{t('reach_out')}</p>

  //           <button className="bg-white bg-opacity-50 py-3 px-5 rounded mt-4">{t('contact_us')}</button>
  //         </div>

  //       </Col>
  //     </Row>
  //   </div>
  // );
};

export default Faq;
